export default {
  path: 'addresses',
  name: 'publisher/addresses',
  props: true,
  meta: { requiresAuth: true },
  component: () => import(/* webpackChunkName: "publisher-show-addresses" */ './Addresses')
}
